import { Component, Inject, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { JwtHelperService } from "@auth0/angular-jwt";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";
declare var $: any;
import { DeepLearningDataService } from "../../../deepLearning/services/deepLearning";

@Component({
    templateUrl: './parking-traffic-alert.component.html',
    styleUrls: ["./parking-traffic-alert.component.css"],

    
    
})
export class parkingAlertComponent implements OnInit {
    public personData: any[] = [];
    public personDataDetails: any;
    tokenDecoded: any = {};
    public apiMetaDataLoading: boolean = false;
    public eventMetaData: any = {};
    public currentImage: any;
    public isimageReady: boolean = false;
    personProfile: any;
    isVideoReady: boolean = false;
    currentvideo: any;
    // isMerakiCam: boolean = false;
    isMerakiCam: boolean = false;
    public isPersonFound: boolean = true;
    private JWT: JwtHelperService = new JwtHelperService();
    constructor(
        private dialog: MatDialog,
        public dialogRef: MatDialogRef<parkingAlertComponent>,
        @Inject(MAT_DIALOG_DATA) public eventData: any,
        private _DeepLearningDataService: DeepLearningDataService
    ) {
    }

    ngOnInit() {
        // 
        this.getAllPersonData();
        this.getTenantFromLocalStorage();
    }
    getAlertData(item: any) {
        // 
        this.isimageReady = false;
        if (this.tokenDecoded.tenantId == 4 && (item.label == 'faceMaskDetected' || item.label == 'socialDistancingViolation')) this.getMetaData(item.objectId);

        this.findPersonName(item.value);
        this.getsnapShotForAlert(item.snapshotImage);
        if (item.snapshotVideo.includes("meraki")) {
            this.isMerakiCam = true;
        }
        else {
            this.isMerakiCam = false;
            this.getvideoForAlert(item.snapshotVideo);
        }
    }
    getTenantFromLocalStorage() {
        // let token = localStorage.getItem('token');
        let token = localStorage.getItem(environment.ProjectName + '-token');
        this.tokenDecoded = this.JWT.decodeToken(token);
    }
    getAllPersonData() {
        this._DeepLearningDataService.getAllPerson().subscribe((res) => {
            this.personData = res.body["data"];
            this.getAlertData(this.eventData);
        });
    }
    getsnapShotForAlert(name) {
        this._DeepLearningDataService.getRequiredFile(name).subscribe((res) => {
            this.currentImage = res.body["url"];
            this.isimageReady = true;
            setTimeout(() => {
                $(".imageZoom").magnificPopup({ type: "image" });
            }, 1000);
        });
    }
    getvideoForAlert(name) {
        this._DeepLearningDataService.getRequiredFile(name).subscribe((res) => {
            this.currentvideo = res.body["url"];
            this.isVideoReady = true;
        }, error => {
           this.isVideoReady = false;
        });
    }
    getMetaData(objectId: string) {
        let todayDate = new Date();
        this.eventMetaData = {};
        this.apiMetaDataLoading = true;

        let range = `${todayDate.getFullYear()}-${(todayDate.getMonth() + 1) > 9 ? todayDate.getMonth() + 1 : '0' + (todayDate.getMonth() + 1)}-${todayDate.getDate() > 9 ? todayDate.getDate() : '0' + todayDate.getDate()}`;
        let query = {
            "queryType": "scan",
            "limit": 10,
            "order": "descending",
            "intervals": [
                "2020-06-29T19:00:00.000Z/" + range + "T18:59:59.999Z"
            ],
            "filter": {
                "type": "and",
                "fields": [
                    {
                        "type": "selector",
                        "dimension": "objectId",
                        "value": objectId
                    }
                ]
            },
            "offset": 0
        };

        this._DeepLearningDataService.videoEventsQuery(query)
            .pipe(map(res => res.body))
            .subscribe(
                (response: any) => {

                    if (response.length > 0) {
                        response[0].events.forEach(element => {
                            this.eventMetaData[element.label] = element.value;
                        });
                    }
                    this.apiMetaDataLoading = false;
                },
                (error) => {
                    this.apiMetaDataLoading = false;
                }
            );
    }
    findPersonName(id) {
        this.isPersonFound = true;
        var findPerson = this.personData.find((x) => x.id == id);
        if (findPerson != null && findPerson.isActive) {
            this.personDataDetails = findPerson;
        } else {
            this.personDataDetails = {
                firstName: "Guest",
                lastName: "",
                employeeTags: [{ name: "Guest" }],
            };
        }
        this.isPersonFound = false;
    }
    showCopyIcon = false; // Initially hide the copy icon

    toggleCopyIcon(): void {
        this.showCopyIcon = !this.showCopyIcon; // Toggle the copy icon
      }
    
    copyTextToClipboard(): void {
        const textToCopy = this.eventData?.objectId;
    
        if (textToCopy) {
          // Create a temporary textarea element to copy the text
          const textarea = document.createElement('textarea');
          textarea.value = textToCopy;
          document.body.appendChild(textarea);
    
          // Select the text inside the textarea
          textarea.select();
          textarea.setSelectionRange(0, textToCopy.length);
    
          // Copy the selected text to the clipboard
          document.execCommand('copy');
    
          // Remove the temporary textarea
          document.body.removeChild(textarea);
          
        }
      }

    closeModel() {
        this.dialogRef.close();
    }
      capitalizeText(text: string): string {
    return text ? text.charAt(0).toUpperCase() + text.slice(1) : '';
  }
}